import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";

export interface IParamDataTableRowFormMeta {
    tva1: FormInputMeta;
    tva2: FormInputMeta;
    hpx: FormInputMeta;
    bank: FormInputMeta;
    
    schema: any;
}

const paramDataTableRowFormMeta = {} as IParamDataTableRowFormMeta;

paramDataTableRowFormMeta.tva1 = {
    name: "tva1",
    label: "TVA1",
    type: "text",
    validation: yup.string().required(),
}
paramDataTableRowFormMeta.tva2 = {
    name: "tva2",
    label: "TVA2",
    type: "text",
    validation: yup.string().required(),
}
paramDataTableRowFormMeta.hpx = {
    name: "hpx",
    label: "Compte HPX",
    type: "text",
    validation: yup.string().required(),
}
paramDataTableRowFormMeta.bank = {
    name: "bank",
    label: "Compte Banque",
    type: "text",
    validation: yup.string().required(),
}

paramDataTableRowFormMeta.schema = yup.object().shape(getValidationSchema(paramDataTableRowFormMeta));

export default paramDataTableRowFormMeta;